import { Tab, Tabs, Typography, Box, Container } from "@mui/material";
import React, { useState } from "react";
import { Module } from "../../../../types/ProgramModel";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import HeadsetIcon from "@mui/icons-material/Headset";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import CreateIcon from "@mui/icons-material/Create";
import GavelIcon from "@mui/icons-material/Gavel";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import TranslateIcon from "@mui/icons-material/Translate";
import ModuleQuestionList from "../../../../components/ModuleQuestionList";
import ReactQuill from "react-quill";
import { useProgram } from "../../../../context/ProgramContext";

interface ProgramModulesProps {
  modules: Module[];
  programId: string;
  weekNumber: number;
}

const ProgramModules: React.FC<ProgramModulesProps> = ({
  modules,
  programId,
  weekNumber,
}) => {
  const { fetchProgramModule, fetchModuleQuestions } = useProgram();
  const [value, setValue] = useState(0);

  // Icons mapping
  const icons: any = {
    Reading: <MenuBookIcon />,
    Listening: <HeadsetIcon />,
    Speaking: <RecordVoiceOverIcon />,
    Writing: <CreateIcon />,
    Grammar: <GavelIcon />,
    Review: <AssignmentTurnedInIcon />,
    Vocabulary: <TranslateIcon />,
  };

  // useEffect(() => {
  //   if (modules.length > 0) {
  //     // Trigger the click event on the first tab programmatically
  //     handleChange(null, 0);
  //   }
  // }, [modules]);

  const handleChange = async (
    event: React.SyntheticEvent | null,
    newValue: number
  ) => {
    setValue(newValue);
    const module = modules[newValue];
    console.log(module);
    if (!module?.description) {
      // Assuming description being empty means data needs fetching
      await fetchProgramModule(module, programId, weekNumber);
    }
    // if (!module?.questions?.length) {
    //   await fetchModuleQuestions(module.moduleId, programId, weekNumber);
    // }
  };

  return (
    <Container>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="learning module tabs"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {modules.map((module, index) => (
          <Tab
            icon={icons[module.name]}
            label={module.name}
            key={module.name}
          />
        ))}
      </Tabs>{" "}
      {modules.map((module, index) => (
        <div hidden={value !== index} key={module.moduleId}>
          <Box p={3}>
            <Typography variant="h6">
              Description for {module.name} module
            </Typography>

            <ReactQuill
              value={module.description}
              style={{ height: "300px" }}
            />
          </Box>
          <Box p={3}>
            <ModuleQuestionList module={module} />
          </Box>
        </div>
      ))}
    </Container>
  );
};

export default ProgramModules;
